export default __webpack_public_path__ + "static/media/05_PETITE_VILLE-min.d00eada6.jpg";